<template>
  <div class="vd-gl-content">
    <mavon-editor v-model="value" class="editor-height" @save="saveCode" />
  </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import marked from 'marked'

const html = marked('link')
export default {
  name: 'edit',
  components: { mavonEditor },
  data() {
    return {
      html,
      value: '# Marked in Node.js\n\nRendered by **marked**.',
    }
  },
  methods: {
    saveCode(value, render) {
      console.log('value', value)
      console.log('render', render)
    },
  },
}
</script>

<style scoped>
.editor-height {
  height: calc(100vh - 220px);
  max-height: calc(100vh - 220px);
  z-index: 99;
}
</style>
